interface IClass {
  id?: string
  title: string
  startDate: string
  startHour: string
  endHour: string
  zoomLink?: string
}

interface IClassRate {
  title: string
  typeformLink: string
  endDateToRate: string
}

interface IChallenge {
  id: string
  title: string
  status: string
  deadline: string
}

export interface ICourse {
  id: string
  camada: number
  title: string
  startDate: string
  endDate: string
  startHour: string
  endHour: string
  days: number[]
  tags: string[]
  percentage: number
  nextClass: IClass
  afterClass: IClass
  classRate: IClassRate
  pendingChallenge: IChallenge
  zoomLink?: string
  certificateLink?: string
  url: string
  accessAvailableFrom: string
  available: boolean
}

export class Course {
  id: string
  camada: number
  title: string
  startDate: string
  endDate: string
  startHour: string
  endHour: string
  days: number[]
  tags: string[]
  percentage: number
  nextClass: IClass
  afterClass: IClass
  classRate: IClassRate
  pendingChallenge: IChallenge
  zoomLink?: string
  certificateLink?: string
  slug: string
  accessAvailableFrom: string
  available: boolean
  constructor(from: ICourse) {
    this.id = from.id
    this.camada = from.camada
    this.title = from.title
    this.startDate = from.startDate
    this.endDate = from.endDate
    this.startHour = from.startHour
    this.endHour = from.endHour
    this.days = from.days
    this.tags = from.tags
    this.percentage = from.percentage
    this.nextClass = from.nextClass
    this.afterClass = from.afterClass
    this.classRate = from.classRate
    this.pendingChallenge = from.pendingChallenge
    this.zoomLink = from.zoomLink
    this.certificateLink = from.certificateLink
    this.slug = from.url
    this.accessAvailableFrom = from.accessAvailableFrom
    this.available = from.available
  }
}
